export const liveEventStatusList = {
    INITIAL: 'initial',
    STARTED: 'started' ,
    STOPPED: 'stopped',
    FAILED: 'failed'
};